// extracted by mini-css-extract-plugin
export default {"profile-block":"profile_profile-block__MD7ea","total-3":"profile_total-3__93jg6","profile-name":"profile_profile-name__vDEeZ"};